import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ChartConfiguration, ChartData, ChartType, Color } from 'chart.js';
import { BaseChartDirective, ThemeService } from 'ng2-charts';

@Component({
  selector: 'app-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.scss'],
  providers: [ThemeService]
})
export class BarComponent implements OnInit {
  @ViewChild(BaseChartDirective)  public chart!: BaseChartDirective;

  @Input() chartData!: Array<{ name: string, values: Array<number> }>;
  @Input() colors?: Array<string>;
  @Input() labels?: Array<string>;
  @Input() tooltipsLabel: Array<Array<string>> = [];

  barChartData: ChartData<'bar'> = { labels: [], datasets: [] };
  barChartType: ChartType = 'bar';
  barChartColors: Color[] = [];

  barChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false
      },
      legend: {
        display: false
      },
      tooltip: {
        enabled: true,
        filter: (tooltip) => {
          return tooltip.dataset.data[tooltip.dataIndex] !== 0
        },
        callbacks: {
          title: (items: any) => {
            return items && items[0] ? items[0].dataset.label : "";
          },
          label: (item: any) => {
            return this.tooltipsLabel[item.datasetIndex][item.dataIndex];
          }
        }
      }
    },
    scales: {
      gridLines: {
        display: false
      },
      X: {
        grid: {
          display: false,
          drawBorder: false
        },
        ticks: {
          display: true,
          maxRotation: 0,
          minRotation: 0,
          font: {
            size: 10
          },
          autoSkip: true,
          autoSkipPadding: 15
        }
      },
      Y: {
        grid: {
          drawBorder: false,
          color: "#e6e6e6",
          lineWidth: 1,
        },
        ticks: {}
      }
    }
  }

  constructor(private themeService: ThemeService) { }

  ngOnInit() {
    this.barChartColors = this.createColors();
    this.createBar();
  }

  public toImage(): string {
    return this.chart?.toBase64Image() || '';
  }

  createBar(): void {
    this.barChartData.datasets = this.chartData.map(({ values, name }, index) => ({
      data: values,
      stack: 'a',
      label: name,
      barPercentage: 1.2,
      backgroundColor: this.barChartColors[index],
      hoverBackgroundColor: this.barChartColors[index]
    }));

    this.barChartData.labels = this.labels ? this.labels : new Array<string>(this.chartData.length ? this.chartData[0].values.length : 1).fill("");

    const maxRange = this.calculateMaximumRange();

    if (this.barChartOptions && this.barChartOptions.scales && this.barChartOptions.scales['Y']) {
      this.barChartOptions.scales['Y'].max = maxRange;

      if (this.barChartOptions.scales['Y'].ticks) {
        this.barChartOptions.scales['Y'].ticks['stepSize'] = maxRange / 5;
      }
    }

    this.themeService.setColorschemesOptions(this.barChartOptions);
    this.chart?.update();
    this.chart?.render();
  }

  updateBar(chartData: Array<{ name: string, values: Array<number> }>, labels?: Array<string>): void {
    this.chartData = chartData;
    this.labels = labels;
    this.createBar();
  }

  calculateMaximumRange(): number {
    if(!this.chartData.length) return 1;

    const rangeValues = new Array<number>(this.chartData[0].values.length).fill(0);

    for (let i = 0; i < this.chartData[0].values.length; i++) {
      for (let j = 0; j < this.chartData.length; j++) {
        rangeValues[i] += this.chartData[j].values[i];
      }
    }

    var maxValue = Math.max(1, Math.max(...rangeValues));
    if(maxValue > 100)
    {
      return Math.ceil(maxValue / 100) * 100;
    }

    return Math.ceil(maxValue / 5) * 5;
  }

  createColors(): Color[] {
    return this.colors ? this.colors : [];
  }

}
